import React, { FC, memo, useCallback } from 'react'
import styled, { StyledProps } from 'styled-components'
import { EColorBgText, sv } from '@ucheba/utils/helpers/styles/variables'
import { Button } from '@ucheba/ui/components/Button/desktop'
import { stringifyUrl } from '@ucheba/utils/helpers/router'
import { useRouter } from 'next/router'
import { useSpecialitiesPageSectionsNavigationCore } from '../bll'
import { ISpecialitiesPageSectionsNavigation } from '../types'

const ButtonItems = styled.div<StyledProps<any>>`
  height: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid ${(props) => sv.color[props.color || 'gold']};
  border-radius: 4px;
  position: relative;

  button {
    border-right: 1px solid ${(props) => sv.color[props.color || 'gold']};
    border-radius: 0;
  }

  button:first-child {
  }

  button:last-child {
    border: none;
  }
`

const ButtonItem = styled<StyledProps<any>>(Button)`
  padding: 12px 12px;
  flex: 1;
  cursor: ${(props) => (props.active ? 'default' : 'pointer')};
  background-color: ${(props) =>
    props.active ? sv.color[props.color || 'gold'] : sv.color.transparent};
  color: ${(props) =>
    props.active ? sv.color[EColorBgText[props.color]] : sv.color[props.color || 'gold']};

  :hover {
  }
`

const SpecialitiesPageSectionsNavigation: FC<ISpecialitiesPageSectionsNavigation> = ({
  href,
}) => {
  const { items, activeIndex } = useSpecialitiesPageSectionsNavigationCore(href)

  const { push } = useRouter()

  const onClickUpdateRouter = useCallback(
    (hrefBtn: string) => {
      push(stringifyUrl(hrefBtn, {}))
    },
    [push]
  )

  return (
    <ButtonItems color='blue'>
      {items.map((item, index) => {
        return (
          <ButtonItem
            key={item.name}
            color='blue'
            active={index === activeIndex}
            onClick={() => {
              if (index !== activeIndex && item.href) {
                onClickUpdateRouter(item.href)
              }
            }}
          >
            {item.name}
          </ButtonItem>
        )
      })}
    </ButtonItems>
  )
}

export default memo(SpecialitiesPageSectionsNavigation)
